// licenses
export const LICENSES = 'licenses'

// payer management
export const ENABLED = 'enabled'
export const LINKED_PATIENTS = 'linkedPatients'
export const NAME = 'name'
export const REFERRAL_SOURCES = 'referralSources'

// patient demographics
export const CLINICIAN = 'clinician'
export const PAYER = 'payer'
export const PROVIDER = 'provider'
export const UUID = 'uuid'
export const REF_VALUE = 'refValue'

// Form
export const FROM = 'from'
export const TO = 'to'
export const DEFAULT_DATE_RANGE = {
  [FROM]: null,
  [TO]: null
}

// interventions
export const ACTIVITY_DATE = 'activityDate'
export const COMPLETION_DATE = 'completionDate'
export const CREATION_DATE = 'creationDate'
export const FIRST_NAME = 'firstName'
export const GOAL = 'goal'
export const GOAL_UUID = 'goalUuid'
export const INTERVENTION = 'intervention'
export const INTERVENTION_UUID = 'interventionUuid'
export const LAST_NAME = 'lastName'
export const PATIENT_FIELD_NAME = 'patient'
export const PATIENT_FIRST_NAME = 'patientFirstName'
export const PATIENT_LAST_NAME = 'patientLastName'
export const PATIENT_STATUS = 'patient.status' // just for consistency with QM Dashboard
export const PATIENT_DIVISION = 'patient.division'
export const PREVENTIVE_TYPE = 'preventiveType'
export const REFERRAL_PAYER = 'referralPayer'
export const REFERRAL_PAYER_UUID = 'referralPayerUuid'
export const REFERRAL_SOURCE = 'referralSource'
export const STATUS = 'status'
export const YEAR = 'year'
export const DIAGNOSIS = 'diagnosis'

// goals
export const TARGET_DATE = 'targetDate'
export const RESPONSIBLE_PARTY = 'responsibleParty'

// patient care plan
export const CATEGORY = 'category'
export const STRENGTH_CATEGORY = 'strengthCategory'
export const STRENGTH_CATEGORY_UUID = 'strengthCategoryUuid'
export const BARRIER_CATEGORY = 'barrierCategory'
export const BARRIER_CATEGORY_UUID = 'barrierCategoryUuid'
export const CREATED_AT = 'createdAt'
export const DISEASE = 'disease'
export const DISEASE_UUID = 'diseaseUuid'
export const INTERVENTIONS = 'interventions'
export const PRIORITY_FIELD_NAME = 'priority'
export const RESPONSIBLE_BY_TYPE = 'responsibleByType'
export const RESPONSIBLE_BY_UUID = 'responsibleByUuid'
export const INSURANCE_PROGRAM_TYPE = 'insuranceProgramType'
export const SHOW_CUSTOM = 'showCustom'
export const SELECTED_GOALS = 'selectedGoals'
export const SELECTED_INTERVENTIONS = 'selectedInterventions'
export const PATIENT_GOAL_GENERAL_FIELDS = 'patientGoalGeneralFields'
export const PATIENT_INTERVENTION_GENERAL_FIELDS =
  'patientInterventionGeneralFields'

// patient change log
export const EMPLOYEE = 'employee'
export const TYPE = 'type'

// consent report
export const CARE_TEAM = 'careTeam'
export const CASE_MANAGER = 'caseManager'
export const FACILITY = 'facility'
export const GROUP = 'group'
export const PATIENT_ID = 'patientId'
export const SENT_AT = 'sentAt'
export const SIGNED_AT = 'signedAt'
export const CONSENT_TYPE = 'consentType'

// urgent care dashboard
export const DATE_FROM = 'dateFrom'
export const DATE_TO = 'dateTo'
export const DIVISION = 'division'
export const DIVISION_UUID = 'divisionUuid'
export const OUTCOME_UUID = 'outcomeUuid'
export const CALL_REASON_UUID = 'callReasonUuid'
export const CONNECTED_CLINICIAN_UUID = 'connectedClinicianUuid'
export const PRIMARY_PROFESSIONAL_TEAM = 'medicalTeam'

// urgent care report
export const ASSIGNED_TO = 'assignedTo'
export const TRIAGE_NURSE_UUID = 'triageNurse'
export const ENROLLED_PROGRAM_STATUS = 'enrolledProgramStatus'
export const FACILITY_UUID = 'facilityUuid'
export const PROVIDER_UUID = 'providerUuid'

// facility caregiver report
export const DATE = 'date'
export const IS_RPM_BILLABLE = 'isRpmBillable'
export const REPORT_TYPE = 'reportType'
export const TIME = 'time'

// referral search
export const LANGUAGE = 'language'
export const PROBLEM = 'problem'

// goal category
export const TITLE = 'title'
export const IS_ACTIVE = 'isActive'

// goal
export const CONTENT = 'content'
export const CATEGORY_UUID = 'categoryUuid'
export const INSURANCE_PROGRAM_TYPES = 'insuranceProgramTypes'
export const IS_HEDIS = 'isHedis'
export const IS_RISK_MITIGATION = 'isRiskMitigation'
export const DAYS_TO_TARGET_DATE = 'daysToTargetDate'
export const INTERNAL_CONTENT = 'internalContent'
export const RECOMMENDED_INTERVENTIONS = 'recommendedInterventions'
export const IS_NOT_RPM_BILLABLE = 'isNotRpmBillable'

// intervention
export const IS_TASK_TEMPLATE_ATTACHED = 'isTaskTemplateAttached'
export const TYPE_TEMPLATE = 'typeTemplate'
export const PRIORITY_TEMPLATE = 'priorityTemplate'
export const SUBJECT_TEMPLATE = 'subjectTemplate'
export const DESCRIPTION_TEMPLATE = 'descriptionTemplate'
export const DAYS_TO_TARGET_DATE_TEMPLATE = 'daysToDueDateTemplate'

// goals
export const RELATED_PROGRAM = 'relatedProgram'

export const FACILITIES = 'facilities'
export const COMPANY_DIVISION = 'companyDivision'

export const FLOOR = 'floor'
export const ROOM = 'room'
export const UNIT = 'unit'

// billing summary
export const FULL_NAME = 'fullName'
export const GROUP_BY = 'groupBy'
export const CASE_MANAGER_UUID = 'caseManagerUuid'
export const INSURANCE_TYPE_UUID = 'insuranceTypeUuid'

// patient activity dashboard
export const ID = 'id'
export const CAREGIVER = 'careGiver'
export const DESCRIPTION = 'description'
export const MEDICAL_DEVICE_TRAINING_STATUS = 'medicalDeviceTrainingStatus'
export const COMPLETED_BY = 'completedBy'

// care plan review date
export const CARE_PLAN_CLINICIAN = 'carePlanClinician'
export const CARE_PLAN_NOTE = 'carePlanNote'
export const CARE_TEAM_UUID = 'careTeamUuid'
export const GROUP_UUID = 'groupUuid'
export const NEXT_CARE_PLAN_REVIEW_DATE = 'nextCarePlanReviewDate'
export const NEXT_CARE_PLAN_REVIEW_DATE_FROM = 'nextCarePlanReviewDateFrom'
export const NEXT_CARE_PLAN_REVIEW_DATE_TO = 'nextCarePlanReviewDateTo'
export const PROGRAM_TYPE = 'programType'
export const REFERRAL_SOURCE_UUID = 'referralSourceUuid'
export const PATIENT_STATUS_FIELD_NAME = 'patientStatus'

export const LOGIN = 'login'
export const IS_LOCKED = 'isLocked'
export const EFFECTIVE_DATE = 'effectiveDate'
export const NOTE = 'note'

// action hub
export const ACTION = 'action'
export const ACTION_TYPE = 'actionType'
export const ASSIGNEE = 'assignee'
export const ATTACHMENTS = 'attachments'
export const CARE_GAP_TYPE = 'careGapType'
export const CARE_GAP_TYPE_CUSTOM_FIELD = 'careGapTypeCustomField'
export const CREATED_BY = 'createdBy'
export const CREATED_DATE_FROM = 'createdDateFrom'
export const CREATED_DATE_TO = 'createdDateTo'
export const CUSTOM_FIELD_VALUES = 'customFieldValues'
export const DUE_DATE = 'dueDate'
export const DUE_DATE_FROM = 'dueDateFrom'
export const DUE_DATE_TO = 'dueDateTo'
export const IS_NO_DUE_DATE = 'isNoDueDate'
export const LAST_ACTIVITY_DATE_FROM = 'lastActivityDateFrom'
export const LAST_ACTIVITY_DATE_TO = 'lastActivityDateTo'
export const MENTIONED_USERS = 'mentionedUsers'
export const NOTIFICATION_TYPE = 'notificationType'
export const PATIENT_REQUESTED_APPOINTMENT = 'patientRequestedAppointment'
export const POINTS = 'points'
export const RELATED_PATIENT = 'relatedPatient'
export const SUBJECT = 'subject'
export const TASK_TYPE = 'taskType'
export const TEXT = 'text'
export const VALUE = 'value'

// referral address
export const REFERRAL_ADDRESS_ADDRESS_PROP = 'address'
export const REFERRAL_ADDRESS_CITY_PROP = 'city'
export const REFERRAL_ADDRESS_STATE_PROP = 'state'
export const REFERRAL_ADDRESS_ZIP_PROP = 'zip'
export const REFERRAL_ADDRESS_TYPE_PROP = 'type'

// referral phones
export const REFERRAL_PHONE_NUMBER_PROP = 'number'
export const REFERRAL_PHONE_TYPE_PROP = 'type'
export const REFERRAL_PHONE_DESCRIPTION_PROP = 'description'

// referral emergency contacts
export const REFERRAL_EMERGENCYCONTACT_NAME_PROP = 'name'
export const REFERRAL_EMERGENCYCONTACT_RELATIONSHIP_PROP = 'relationship'
export const REFERRAL_EMERGENCYCONTACT_PHONE_PROP = 'phoneNumber'
export const REFERRAL_EMERGENCYCONTACT_ADDRESS_PROP = 'address'
export const REFERRAL_EMERGENCYCONTACT_EMAIL_PROP = 'email'
export const REFERRAL_EMERGENCYCONTACT_NOTE_PROP = 'note'

// referral insurances
export const REFERRAL_INSURANCE_POLICYNUMBER_PROP = 'policyNumber'
export const REFERRAL_INSURANCE_GROUPNUMBER_PROP = 'groupNumber'
export const REFERRAL_INSURANCE_PLANNAME_PROP = 'planName'
export const REFERRAL_INSURANCE_EFFECTIVEDATE_PROP = 'effectiveDate'
export const REFERRAL_INSURANCE_EXPIRATIONDATE_PROP = 'expirationDate'
export const REFERRAL_INSURANCE_INSURANCE_PROP = 'insurance'
export const REFERRAL_INSURANCE_ORDER_PROP = 'orderNumber'

export const PROVIDED_BY = 'providedBy'
export const DUE_DATE_TYPE = 'dueDateType'

export const MEDICAL_DEVICE_TRAINING_DATE = 'medicalDeviceTrainingDate'

export const CALL_TYPE = 'callType'

export const DEFAULT_CALL_DURATION = 'defaultCallDuration'
export const COLOR = 'color'

export const PHONE = 'phone'
export const START_DATE = 'startDate'

// Patient address
export const PATIENT_ADDRESS_ADDRESS_PROP = 'address'
export const PATIENT_ADDRESS_CITY_PROP = 'city'
export const PATIENT_ADDRESS_STATE_PROP = 'state'
export const PATIENT_ADDRESS_ZIP_PROP = 'zip'
export const PATIENT_ADDRESS_TYPE_PROP = 'type'
export const PATIENT_ADDRESS_PRIMARY_PROP = 'isPrimary'

// Patient phone numbers
export const PATIENT_PHONE_NUMBER_PROP = 'number'
export const PATIENT_PHONE_TYPE_PROP = 'type'
export const PATIENT_PHONE_DESCRIPTION_PROP = 'description'

// Patient emails
export const PATIENT_EMAIL_EMAIL_PROP = 'email'
export const PATIENT_EMAIL_TYPE_PROP = 'type'
export const PATIENT_EMAIL_DESCRIPTION_PROP = 'description'

// Patient allergies
export const PATIENT_ALLERGY_NAME_PROP = 'allergy'
export const PATIENT_ALLERGY_DESCRIPTION_PROP = 'description'

// Patient problems/diseases
export const PATIENT_DISEASE_DISEASE_PROP = 'name'
export const PATIENT_DISEASE_DISEASE_ENTITY_PROP = 'disease'
export const PATIENT_DISEASE_PRIMARY_PROP = 'isPrimary'
export const PATIENT_DISEASE_STARTDATE_PROP = 'startDate'
export const PATIENT_DISEASE_ENDDATE_PROP = 'endDate'

// Patient diagnoses
export const PATIENT_DIAGNOSIS_DIAGNOSIS_PROP = 'icd10'
export const PATIENT_DIAGNOSIS_PROGNOSIS_PROP = 'prognosis'
export const PATIENT_DIAGNOSIS_STARTDATE_PROP = 'startDate'
export const PATIENT_DIAGNOSIS_ENDDATE_PROP = 'endDate'
export const PATIENT_DIAGNOSIS_PRIMARY_PROP = 'isPrimary'
export const PATIENT_DIAGNOSIS_SECONDARY_PROP = 'isSecondary'
export const PATIENT_DIAGNOSIS_PRIORITY_PROP = 'orderNumber'

// Patient emergency contacts
export const PATIENT_EMERGENCYCONTACT_NAME_PROP = 'name'
export const PATIENT_EMERGENCYCONTACT_RELATIONSHIP_PROP = 'relationship'
export const PATIENT_EMERGENCYCONTACT_PHONE_PROP = 'phoneNumber'
export const PATIENT_EMERGENCYCONTACT_ADDRESS_PROP = 'address'
export const PATIENT_EMERGENCYCONTACT_EMAIL_PROP = 'email'
export const PATIENT_EMERGENCYCONTACT_NOTE_PROP = 'note'
